module.exports = __webpack_public_path__ + "static/img/jingying2.1f4dbd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/jingying2.png
// module id = FLnG
// module chunks = 0